const headerSetValue = (data, operation) => {
    const { fieldToSet, valueToSet } = operation

    if (!data) return data

    // Return new object instead of mutating
    return {
        ...data,
        [fieldToSet]: valueToSet
    }
}

export default headerSetValue
